export const GET_SCHEDULED_ACTIVITIES = '/scheduled_activity/query';
export const GET_SCHEDULED_ACTIVITY = '/scheduled_activity/';
export const PUT_SCHEDULED_ACTIVITY = '/scheduled_activity/';
export const DELETE_SCHEDULED_ACTIVITY = '/scheduled_activity/';
export const DOWNLOAD_SCHEDULED_ACTIVITY_FILE = '/scheduled_activity/download/';
